<article class="message is-info">
  <div class="message-body">
    <p class="block">
      Your charity ownership could not be automatically verified.  
    </p>
    <p class="block">
      To verify your ownership we need to perform
      some additional checks. Please hold tight and we will contact you as soon as possible.
    </p>

    <p class="block">You may browse offers, but you will not be able to make requests until ownership is
      verified.</p>
  </div>
</article>

<script lang="ts">
  import { appState } from "../../../lib/appState.js";
  $: email = $appState.auth_user?.email;
</script>
